// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__m8I9W","footer":"ModalUpdate_footer__IwTx9"};